module.exports = __webpack_public_path__ + "static/img/1-1.9a4b8ab5.jpeg";